import { IntegrationInterface, IntegrationUseCaseEnum } from '../types'

export const GOOGLE_INTEGRATIONS_PATH = '/api/dashboard/google-integration'

export const GOOGLE_INTEGRATIONS_API = `${GOOGLE_INTEGRATIONS_PATH}/integrations`

export const getGoogleAuthUrlPath = (useCase: IntegrationUseCaseEnum) => {
  return `${GOOGLE_INTEGRATIONS_PATH}/integrations/${useCase}/auth-url`
}

export const getGoogleReconnectAuthUrlPath = (id: IntegrationInterface['id']) => {
  return `${GOOGLE_INTEGRATIONS_PATH}/integrations/${id}/reconnect-auth-url`
}

export const getGoogleIntegrationSendCode = (code: string) => {
  return `${GOOGLE_INTEGRATIONS_PATH}/auth?code=${code}`
}
